(function (app, ng) {
    messageModalController.$inject = ["$mdDialog"];

    function messageModalController($mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            UI: {
                isClosing: false
            },
            close: close
        });

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.hide();
        }
    }

    app.provider("figMessageModal", [function () {
        this.$get = ["$mdDialog", function ($mdDialog) {
            var service = {};

            service.show = function (message, event) {
                var options = {
                    controller: messageModalController,
                    controllerAs: "$ctrl",
                    templateUrl: "/App/Services/MessageModal/template.html",
                    bindToController: true,
                    locals: { message: message }
                };

                if (event)
                    options.targetEvent = event;

                return $mdDialog.show(options);
            };

            return service;
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line